import React, { useState, useRef, useEffect } from "react";
import "./AattumGallery.css";

const Gallery = () => {
  const [showMore, setShowMore] = useState(false);
  const secondBlockRef = useRef(null);

  const handleToggle = () => {
    setShowMore(!showMore);
  };

  useEffect(() => {
    if (showMore && secondBlockRef.current) {
      setTimeout(() => {
        secondBlockRef.current.scrollIntoView({ behavior: "smooth" });
      }, 300);
    }
  }, [showMore]);

  const GalleryBlock = ({ images, animated }) => (
    <div className={`gallery-gridSR ${animated ? "fadeInSR" : ""}`}>
      {images.map((item, index) => (
        <div className="gallery-itemSR" key={index}>
          <img src={item.img} alt="Gallery" />
          <div className="gallery-infoSR">
            <p>{item.title}</p>
            <span>{item.subtitle}</span>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <section className="cricket-gallery-secSR">
      <h2 className="gallery-titleSR">Check Out Our Gallery</h2>
      <p className="gallery-subtitleSR">A Collection of Memorable Moments</p>

    <div className="gallery-wrapperSR">

  {/* First 6 images */}
  <div className="gallery-blockSR">
    <GalleryBlock images={galleryData.slice(0, 6)} />
  </div>

  {/* Next 6 images only when clicked */}
  {showMore && (
    <div ref={secondBlockRef} className="gallery-blockSR gallery-secondSR">
      <GalleryBlock images={galleryData.slice(6, 12)} animated />
    </div>
  )}

</div>


      {/* Button */}
      <div className="view-allSR">
        <button onClick={handleToggle}>
          {showMore ? "View Less" : "View More"}
        </button>
      </div>
    </section>
  );
};

export default Gallery;

// 12 images here
const galleryData = [
  { img: "/Images/12 (3).jpg", title: "FFC Festival", subtitle: "Celebration Moments" },
  { img: "/Images/G5.jpeg.jpg", title: "MRFC Champions", subtitle: "Season 3" },
  { img: "/Images/G10.jpeg.jpg", title: "Gym Session", subtitle: "Fitness Photoshoot" },
  { img: "/Images/G9.jpeg.jpg", title: "Award Ceremony", subtitle: "All Winners Together" },
  { img: "/Images/19 (3).jpg", title: "Celebration Night", subtitle: "Winning Moments" },
  { img: "/Images/G6.jpeg.jpg", title: "Trophy Lift", subtitle: "Championship Glory" },
  
  // second 6 images
  { img: "/Images/G1.jpeg.jpg", title: "Team Huddle", subtitle: "Unity and Strength" },
  { img: "/Images/G2.jpeg.jpg", title: "Fan Moments", subtitle: "Audience Cheers" },
  { img: "/Images/G8.jpeg.jpg", title: "Training Day", subtitle: "Practice Session" },
  { img: "/Images/G4.jpeg.jpg", title: "Celebration Shot", subtitle: "Victory Mood" },
  { img: "/Images/G11.jpeg.jpg", title: "Match Highlight", subtitle: "Action Click" },
  { img: "/Images/G3.jpeg.jpg", title: "Final Stage", subtitle: "Grand Ending" }
];
